import React, { useState, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

// Components
import Header from './components/Header';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import EnvFileViewer from './pages/EnvFileViewer';
import AdminPanel from './pages/AdminPanel';
import NotFound from './pages/NotFound';
import PendingApproval from './pages/PendingApproval';

// Context
import { AuthProvider, AuthContext } from './context/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Box minH="100vh" bg="gray.50" _dark={{ bg: "gray.800" }}>
          <Header />
          <Box maxWidth="1400px" mx="auto" px={{ base: 4, md: 12 }} py={8}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/pending-approval" element={<PendingApprovalRoute><PendingApproval /></PendingApprovalRoute>} />
              <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/env-file/:fileKey" element={<PrivateRoute><EnvFileViewer /></PrivateRoute>} />
              <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
        </Box>
      </AuthProvider>
    </Router>
  );
}

// Private route component
function PrivateRoute({ children }) {
  const isAuthenticated = localStorage.getItem('auth_token') !== null;
  const isPendingApproval = localStorage.getItem('pending_approval') === 'true';
  
  if (isPendingApproval) return <Navigate to="/pending-approval" />;
  if (!isAuthenticated) return <Navigate to="/login" />;
  
  return children;
}

// Admin route component
function AdminRoute({ children }) {
  const isAuthenticated = localStorage.getItem('auth_token') !== null;
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = user?.is_admin === true;
  const isPendingApproval = localStorage.getItem('pending_approval') === 'true';
  
  if (isPendingApproval) return <Navigate to="/pending-approval" />;
  if (!isAuthenticated) return <Navigate to="/login" />;
  if (!isAdmin) return <Navigate to="/" />;
  
  return children;
}

// Pending approval route component
function PendingApprovalRoute({ children }) {
  const isPendingApproval = localStorage.getItem('pending_approval') === 'true';
  const isAuthenticated = localStorage.getItem('auth_token') !== null;
  
  if (!isPendingApproval && isAuthenticated) return <Navigate to="/" />;
  if (!isPendingApproval && !isAuthenticated) return <Navigate to="/login" />;
  
  return children;
}

export default App;
